module.exports = __webpack_public_path__ + "img/document-batch-processing.7b31db8a.svg";